export const LIMITS_REMINDER_SPORTSBOOK_GAME_ID = "sportsbook";
